<template><div><h1>VUX Next released</h1>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[feature] Add prop:type</li>
</ul>
<h2><a href="/en/components/swipeout.html">Swipeout</a></h2>
<ul><li>[feature] Add prop:disabled</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX Next released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// next-64.vue?37a4f5a6